import {SettleRecordCommandBody} from '@secretaa/contracts-data';
import {z} from 'zod';
const uuid=z.string().uuid();
export const JournalSlot=z.object({workspaceId:uuid,projectId:uuid,collectionId:uuid,subjectId:uuid,recordId:uuid.nullable()}).strict();
export type JournalSlot=z.infer<typeof JournalSlot>;
export const RecordCommandJournal=SettleRecordCommandBody.extend({
 version:z.literal(1),slot:JournalSlot,expectedVersion:z.number().int().positive().nullable(),
}).strict().refine(j=>j.operation==='CREATE'?j.slot.recordId===null&&j.expectedVersion===null:j.slot.recordId!==null&&j.expectedVersion!==null);
export type RecordCommandJournal=z.infer<typeof RecordCommandJournal>;
export const JOURNAL_EVENT='saa:record-command-journal';
const key=(slot:JournalSlot)=>{const s=JournalSlot.parse(slot);return `saa.record-command.v1:${s.subjectId}:${s.workspaceId}:${s.projectId}:${s.collectionId}:${s.recordId??'create'}`;};
export function readRecordCommandJournal(slot:JournalSlot):RecordCommandJournal|null{
 const raw=sessionStorage.getItem(key(slot));if(raw===null)return null;if(raw.length>4096)throw new Error('INVALID_RECORD_JOURNAL');
 const journal=RecordCommandJournal.parse(JSON.parse(raw));
 if(key(journal.slot)!==key(slot))throw new Error('RECORD_JOURNAL_SCOPE_MISMATCH');return journal;
}
export function saveRecordCommandJournal(input:RecordCommandJournal){
 const journal=RecordCommandJournal.parse(input),before=readRecordCommandJournal(journal.slot);
 if(before&&JSON.stringify(before)!==JSON.stringify(journal))throw new Error('RECORD_JOURNAL_PENDING');
 const encoded=JSON.stringify(journal);sessionStorage.setItem(key(journal.slot),encoded);
 if(sessionStorage.getItem(key(journal.slot))!==encoded)throw new Error('RECORD_JOURNAL_UNAVAILABLE');
 window.dispatchEvent(new Event(JOURNAL_EVENT));
}
export function clearRecordCommandJournal(slot:JournalSlot,idempotencyKey:string){
 const before=readRecordCommandJournal(slot);
 if(before&&before.idempotencyKey!==idempotencyKey)throw new Error('RECORD_JOURNAL_PENDING');
 sessionStorage.removeItem(key(slot));if(sessionStorage.getItem(key(slot))!==null)throw new Error('RECORD_JOURNAL_UNAVAILABLE');
 window.dispatchEvent(new Event(JOURNAL_EVENT));
}
